var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon/user/default","stroke":"currentColor","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"id":"Group","transform":"translate(8.500000, 7.000000)"},[React.createElement("path",{"d":"M23,25.875 L23,23 C23,19.8243627 20.4256373,17.25 17.25,17.25 L5.75,17.25 C2.57436269,17.25 0,19.8243627 0,23 L0,25.875","id":"Path","key":0}),React.createElement("circle",{"id":"Oval","cx":"11.5","cy":"5.75","r":"5.75","key":1})])));
}

User.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 40 40","version":"1.1"};

module.exports = User;

User.default = User;
